import { BaseApiResponseType } from 'src/models/BaseApi';
import { Enums } from 'src/models/enums';
import { SidebarModelResponse } from 'src/models/Partner/Sidebar';
import { ValueOf } from 'src/utils/types';

export const convertToClientUserModel = (serverUserModel: ResponseUserType): UserModel => ({
  id: serverUserModel.ID,
  firstName: serverUserModel.FirstName,
  lastName: serverUserModel.LastName,
  color: serverUserModel.Color,
  email: serverUserModel.Email,
  imageUri: serverUserModel.ImageUri,
  IsAuthenticated: serverUserModel.IsAuthenticated,
  isAdministrator: serverUserModel.IsAdministrator,
  isOrganizerOrCampaignAdministrator: serverUserModel.IsOrganizerOrCampaignAdministrator,
  canViewMyAccountButton: serverUserModel.CanViewMyAccountButton,
  canViewBeamerButton: serverUserModel.CanViewBeamerButton,
  organizationIdString: serverUserModel.OrganizationInfo?.OrganizationIdString,
  organizationInfo: serverUserModel.OrganizationInfo,
  UserTypeCode: serverUserModel.UserTypeCode,
});

export type ResponseUserType = {
  ID: number | null;
  FirstName: string | null;
  LastName: string | null;
  Color: string | null;
  Email: string | null;
  FirstLoginDate: string | null;
  CreatedDate: string | null;
  UserGroup: string | null;
  ImageUri: string | null;
  IsAuthenticated: boolean;
  IsAdministrator: boolean;
  IsCurrentOrganizationAdministrator: boolean;
  IsOrganizerOrCampaignAdministrator: boolean;
  CurrentOrganizationStatus: number;
  CanViewMyAccountButton: boolean;
  CanViewBeamerButton: boolean;
  OrganizationInfo: {
    OrganizationUrl: string;
    OrganizationIdString: string;
    CountryCode: string;
    CommonName: string; // org common name
    RegionCode: string;
    Is501C: boolean;
    IsStripeConfigured: boolean;
  };
  UserTypeCode: ValueOf<typeof Enums.common.UserTypeCode>;
  OrganizationUserRole: ValueOf<typeof Enums.organizations.StaffRoleCode>;
};

export type GetSigninInfoType = {
  UserModel: ResponseUserType;
  LeftMenuModel: SidebarModelResponse;
};

export type UserModel = BaseApiResponseType<{
  id: number | null;
  firstName: string | null;
  lastName: string | null;
  color: string | null;
  email: string | null;
  imageUri: string | null;
  IsAuthenticated: boolean;
  isAdministrator: boolean;
  isOrganizerOrCampaignAdministrator: boolean;
  canViewMyAccountButton: boolean;
  canViewBeamerButton: boolean;
  organizationIdString: string | null;
  organizationInfo: ResponseUserType['OrganizationInfo'];
  UserTypeCode: ResponseUserType['UserTypeCode'];
}>;
